import React, { useState } from 'react';
import styled from '@emotion/styled';
import { theme } from '../../themes/default-theme';
import { Grid, Box } from '@mui/material';
import { ReactSVG } from 'react-svg';

import Banner from '../../components/multimedia/HeroBannerSmall';
import { RespImg } from '../../components/ui';
import NextLink from '../../components/navigation/NextLink'
import IconLink from '../../components/ui/IconLink';
import HomeSocialGrid from '../../components/multimedia/HomeSocialGrid';
import refactorRespImg from '../../data-restructure/ui/resp-img';

import facebook from '../../assets/icons/facebook-ambas.svg';
import instagram from '../../assets/icons/instagram-ambas.svg';
import youtube from '../../assets/icons/youtube-ambas.svg';
import linkedIn from '../../assets/icons/linkedin-ambas.svg';
import twitter from '../../assets/icons/twitter-ambas.svg';

const downSm = '@media (max-width: 939.95px)' // '@media (max-width: 839.95px)';
const upMd = '@media (min-width: 940px)' // '@media (min-width: 840px)';

const Wrapper = styled.div`
  ${theme.breakpoints.up('sm')} {
    // margin-top: 74.15px;
  }
  ${upMd} {
    margin-top: 87px;
  }
`

const TopWrapper = styled.div`
	max-width: 1600px;
	position: relative;
  background-color: ${theme.palette.white};
	padding: 40px 0;
	margin: 0 auto;

  ${theme.breakpoints.up('md')} {
		padding: 60px 0;
  }
  ${theme.breakpoints.up('lg')} {
		padding: 72px 0;
	}

	.TopBox {
		margin-bottom: 48px;
	}
`

const BottomWrapper = styled.div`
  padding-top: 30px;

  ${theme.breakpoints.up('md')} {
		padding-top: 60px;
  }
  ${theme.breakpoints.up('lg')} {
		padding-top: 120px;
	}

	img {
		width: 100%;
	}
`

const PageContainer = styled.div`
  max-width: 1440px;
  font-weight: 700;
  margin: 0 auto;
  & .hide-for-large {
    ${theme.breakpoints.up('md')} {
      display: none;
    }
  }
  & .hide-for-small {
    ${theme.breakpoints.down('sm')} {
      display: none;
    }
  }
`

const AmbassadorTitle = styled.div`
	font-size: 34px;
	font-weight: 800;
	line-height: 38px;
	text-transform: uppercase;
	text-align: center;
  color: ${theme.palette.charcoal};

  ${theme.breakpoints.down('sm')} {
		font-size: 24px;
  }
`

const AmbassadorSubtitle = styled.div`
	color: #758094;
	text-align: center;
	font-family: Open Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 23px;
	margin-top: 23px;

  ${theme.breakpoints.down('sm')} {
		font-size: 14px;
		line-height: 20px;
		margin-top: 15px;
  }
`

const AmbassadorImage = styled.div`
  width: 100%;
	position: relative;
	
	& img {
		width: 100%;
	}

  ${theme.breakpoints.down('sm')} {
		margin-bottom: 26px;
		border-top-left-radius: 50px;
  }
`

const AmbassadorDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${theme.palette.gunmentalGrey};
  margin-bottom: 26px;

  ${theme.breakpoints.down('sm')} {
    font-size: 14px;
  }
`

const SocialsContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: 18px;
	margin-top: 22px;
`

const AmbassadorIcon = styled.div`
	position: relative;
	width: 46px;
	height: 46px;
	display: block;

	&.twitter,
	&.linkedin {
		border-radius: 100%;
		border: 1px solid #D6D6D6;
		background: #FFF;

		svg {
			width: 20px;
			height: 20px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}

		g,
		path {
			fill: #0170D4;
		}
	}
`

const IntroContainer = styled.div`
	text-align: center;
	max-width: 780px;
	margin-bottom: 48px;
`

const IntroTitle = styled.div`
	color: #2E3238;
	font-size: 34px;
	font-weight: 800;
	text-transform: uppercase;
	color: ${theme.palette.charcoal};

	${theme.breakpoints.down('sm')} {
		font-size: 16px;
  }
`

const StyledGrid = styled(Grid)`
	padding-left: 16px;
	padding-right: 16px;
`

const ArticleGrid = styled(Grid)`
	margin-bottom: 78px;

	${theme.breakpoints.down('md')} {
		margin-bottom: 30px;
  }
	
	${theme.breakpoints.up('lg')} {
		padding-right: 3px;
	}

	& img {
		object-fit: cover;

		${theme.breakpoints.up('lg')} {
			min-height: 193px;
			max-height: 304px;
		}
	}
`

const CaptionContainer = styled.div`
	padding: 12px;
	margin-top: -4px;
	background: ${theme.palette.white};
	padding-left: 0;
	padding-right: 0;

	${theme.breakpoints.only('md')} {
		width: 100%;
		height: max-content;
		padding: 0;
	}

	${theme.breakpoints.up('lg')} {
		padding: 26px;
		min-height: 170px;
	}
`

const ArticleTitle = styled.div`
	font-size: 18px;
	font-weight: 700;
	padding-bottom: 4px;
	color: ${theme.palette.charcoal};

	${theme.breakpoints.up('lg')} {
		min-height: 55px;
		overflow: hidden;
	}

	${theme.breakpoints.down('sm')} {
		font-size: 14px;
		padding-bottom: 8px;
	}
`

const ArticleDescription = styled.div`
	font-size: 16px;
	font-weight: 400;
	padding-bottom: 4px;
	color: ${theme.palette.gunmentalGrey};
	margin-top: 10px;
	margin-bottom: 10px;

	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	overflow: hidden;

	${theme.breakpoints.down('sm')} {
		font-size: 14px;
	}
`

const StyledLink = styled.a`
	${theme.breakpoints.only('md')} {
		display: flex;
		align-items: center;
		gap: 40px;
	}
`

const IconLinkContainer = styled.div`
	margin-top: 18px;
	display: block;
`

const AmbassadorsPage = (props) => {

    console.log('relatedArticles: ', props.relatedArticles);
    return (
        <Wrapper>
            {props.heroBanner &&
                <Banner
                    {...props.heroBanner[0]}
                    priority="high"
                />
            }
            <TopWrapper>
                <PageContainer>
                    <Grid container className={'hasPadding'} spacing={0} direction={'row'} justifyContent={'center'}>
                        <Grid
                            size={{
                                xs: 12,
                                md: 7
                            }}>
                            <Box px={2} className={'TopBox'}>
                                {props.title && <AmbassadorTitle dangerouslySetInnerHTML={{ __html: props.title }} />}
                                {props.subtitle && <AmbassadorSubtitle dangerouslySetInnerHTML={{ __html: props.subtitle }} />}
                                <SocialsContainer>
                                    {props.instagram &&
                                        <AmbassadorIcon>
                                            <NextLink legacyBehavior>
                                                <a href={props.instagram}>
                                                    <ReactSVG src={instagram} />
                                                </a>
                                            </NextLink>
                                        </AmbassadorIcon>
                                    }
                                    {props.youtube &&
                                        <AmbassadorIcon>
                                            <NextLink legacyBehavior>
                                                <a href={props.youtube}>
                                                    <ReactSVG src={youtube} />
                                                </a>
                                            </NextLink>
                                        </AmbassadorIcon>
                                    }
                                    {props.facebook &&
                                        <AmbassadorIcon>
                                            <NextLink legacyBehavior>
                                                <a href={props.facebook}>
                                                    <ReactSVG src={facebook} />
                                                </a>
                                            </NextLink>
                                        </AmbassadorIcon>
                                    }
                                    {props.linkedIn &&
                                        <AmbassadorIcon className={'linkedin'}>
                                            <NextLink legacyBehavior>
                                                <a href={props.linkedIn}>
                                                    <ReactSVG src={linkedIn} />
                                                </a>
                                            </NextLink>
                                        </AmbassadorIcon>
                                    }
                                    {props.twitter &&
                                        <AmbassadorIcon className={'twitter'}>
                                            <NextLink legacyBehavior>
                                                <a href={props.twitter}>
                                                    <ReactSVG src={twitter} />
                                                </a>
                                            </NextLink>
                                        </AmbassadorIcon>
                                    }
                                </SocialsContainer>
                            </Box>
                            <Box px={2}>
                                {props.ambassadorImage &&
                                    <AmbassadorImage>
                                        <RespImg
                                            {...props.ambassadorImage}
                                        />
                                    </AmbassadorImage>
                                }
                                {props.description && <AmbassadorDescription dangerouslySetInnerHTML={{ __html: props.description }} />}
                            </Box>
                        </Grid>
                    </Grid>
                </PageContainer>
            </TopWrapper>
            {props.relatedArticles.length > 0 &&
                <BottomWrapper>
                    <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap={'wrap'} alignItems={'flex-start'}>
                        <Grid size={12}>
                            <Box px={2}>
                                <IntroContainer>
                                    <IntroTitle>BLOG POSTS</IntroTitle>
                                </IntroContainer>
                            </Box>
                        </Grid>
                    </Grid>
                    <StyledGrid container className={'hasPadding'} spacing={0} direction={'row'} wrap="wrap">
                        {props.relatedArticles && props.relatedArticles.slice(0, 3).map(function (article, index) {
                            var articleImage = article.acf_article.artThumbnailImage ? refactorRespImg(article.acf_article.artThumbnailImage, [{
                                size: 'default',
                                key: 'image_size_466x314'
                            }]) : null;

                            return (
                                <ArticleGrid key={index} item size={{xs: 12, lg: 4}}>
                                    <NextLink legacyBehavior href={`/community/article/${article.uri}`}>
                                        <StyledLink>
                                            {articleImage &&
                                                <RespImg
                                                    {...articleImage}
                                                />
                                            }
                                            <CaptionContainer>
                                                {article.title && <ArticleTitle dangerouslySetInnerHTML={{ __html: article.title }} />}
                                                {article.acf_article.artTeaserCopy && <ArticleDescription dangerouslySetInnerHTML={{ __html: article.acf_article.artTeaserCopy }} />}
                                                <IconLinkContainer>
                                                    <IconLink colour="vividBlue" href={`/community/article/${article.uri}`} link={{ href: `/community/article/${article.uri}`, title: 'READ MORE' }} />
                                                </IconLinkContainer>
                                            </CaptionContainer>
                                        </StyledLink>
                                    </NextLink>
                                </ArticleGrid>
                            )
                        })}
                    </StyledGrid>
                </BottomWrapper>
            }
            {props.fbPageId &&
                <HomeSocialGrid
                    hashtag={props.hashtag}
                    token={props.fbPageId}
                    countryCode={props.hashtag}
                />
            }
        </Wrapper>
    );
}

export default AmbassadorsPage;